import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { LabeledInfo } from 'ui-components/components/labeled-info-list/labeled-info';
import OrderNumberLink from '../../../../../components/order-number-link';

import messages from '../../messages';

const OrderNumbers = ({ data: orderData }) => {
  const intl = useIntl();
  return (
    <LabeledInfo
      label={intl.formatMessage(messages.orderLabel, {
        count: orderData.length,
      })}
    >
      {orderData.map(({ orderNumber, salesOrderId, fulfillmentPlanId }) => (
        <OrderNumberLink
          key={`${salesOrderId}-${fulfillmentPlanId}`}
          id={`${fulfillmentPlanId}`}
          orderNumber={orderNumber}
          salesOrderId={salesOrderId}
          shouldBypassReadOnlyStoreCheck
        />
      ))}
    </LabeledInfo>
  );
};

OrderNumbers.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      orderNumber: PropTypes.string,
      salesOrderId: PropTypes.string,
      fulfillmentPlanId: PropTypes.number, // This is a number now, going to be changed to a string.
    }),
  ).isRequired,
};

export default OrderNumbers;
